import { useState, useEffect } from "react"
import { ContatoKeys, IContato } from "../../../../../../../application/models"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, Grid, TextField } from "@mui/material"
import { contatoKeyToLabel } from "../../../detalhes-do-projeto/filtros/contatos"
// Icon
import { useAppSelector } from "../../../../../../hooks/store-hooks"

export const RecorteContato = () => {
    const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    // Use State
    const [selectedContato, setSelectedContato] = useState<IContato[]>([])
    // Hook
    const { syncFilterWithForm, removeFilterFromForm,  } = useRecortesExtracaoService()

    useEffect(() => {
        const contatosSelecionados = createRecorteExtracaoForm.fields.Filtros?.contato || [];

        if (contatosSelecionados.length > 0) {
            setSelectedContato(contatosSelecionados);
        } else {
            setSelectedContato([]);
        }
    }, [createRecorteExtracaoForm.fields.Filtros?.contato]);

    // Filtra as opções para remover os itens já selecionados
    const filteredContatos = ContatoKeys.filter((contato: IContato) =>
        !selectedContato.some((selected: IContato) => selected === contato)
    );

    const handleContatoSelectionChange = (value: IContato[]) => {
        setSelectedContato(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'contato',
                value: value,
                formType: 'create'
            });
        } else {
            removeFilterFromForm({
                filtro: 'contato',
                formType: 'create'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredContatos}
                    getOptionLabel={(option) => contatoKeyToLabel(option).toUpperCase()}
                    sx={{
                        px: 2
                    }}
                    value={selectedContato}
                    onChange={(event, value) => {
                        handleContatoSelectionChange(value);
                    }}
                    noOptionsText='Nenhum contato encontrado'
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Lista de tipos de contato"
                        />
                    )}
                />
            </Grid>
        </>
    )
}